import React,{ useState } from 'react'
import { sendMail } from '../../../services/Home/index.js'
import { notifyError, notifySuccess } from "../../../utils/toastError.js"
import Loader from '../../../components/Loader'

const styles = {
    contactUsFormContainer: "flex flex-col lg:flex-row items-center justify-center",
    inputFieldContainer: "shadow appearance-none border rounded-lg w-full py-3 px-3 my-2 lg:my-0 text-gray-500 leading-tight focus:outline-none focus:shadow-outline lg:mr-6 bg-gray-100",
    inputField: "outline-none border-none w-full bg-transparent",
}

const ContactUsForm = () => {
    const [loading, setLoading] = useState(false)

    const [contact, setContact] = useState({
        firstName: '',
        lastName: '',
        contactNumber: '',
        email: '',
        message: '',
    });


    const handleChange = (e) => {
        setContact({
            ...contact,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        if(!contact.firstName){
            notifyError("First Name is required");
            return;
        }
        if(!contact.lastName){
            notifyError("Last Name is required");
            return;
        }
        if(!contact.contactNumber ){
            notifyError("Contact Number is required");
            return;
        }
        if(contact.contactNumber.length < 11 || contact.contactNumber.length > 20){
            notifyError("Contact Number must be between 11 and 20 digits");
            return;
        }
        if(!contact.email){
            notifyError("Email is required");
            return;
        }
        const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if(!regex.test(contact.email)){
            notifyError("Email is not valid");
            return;
        }
        if(!contact.message){
            notifyError("Message is required");
            return;
        }
        if(contact.message.length < 10){
            notifyError("Message must be at least 10 characters");
            return;
        }
        sendMail(contact)
        .then(res => {
            if(res.status === 200){
                setLoading(false);
                notifySuccess("Email sent successfully");
                setContact({
                    firstName: '',
                    lastName: '',
                    contactNumber: '',
                    email: '',
                    message: '',
                });
            }
        }
        ).catch(err => {
            setLoading(false);
            notifyError("Error sending email");
        });
      
    }

  return (
    <>
        {loading ? <Loader /> : null}
        <div className="p-5">
            {/* First Name and Last Name */}
            <div className={styles.contactUsFormContainer}>
                <div className={styles.inputFieldContainer}>
                    <input 
                        className={styles.inputField}
                        id="fname" 
                        type="text" 
                        placeholder="FIRST NAME" 
                        name="firstName"
                        value={contact.firstName}
                        onChange={handleChange}
                    />
                </div>
                <div className={styles.inputFieldContainer}>
                    <input 
                        className={styles.inputField}
                        id="lname" 
                        type="text" 
                        placeholder="LAST NAME" 
                        name="lastName"
                        value={contact.lastName}
                        onChange={handleChange}
                    />
                </div>
            </div>

            {/* Contact Number and Email */}
            <div className={styles.contactUsFormContainer.concat(" mt-5")}>
                <div className={styles.inputFieldContainer}>
                    <input 
                        className={styles.inputField}
                        id="contactNumber"
                        type="number"
                        placeholder="CONTACT NUMBER"
                        name="contactNumber"
                        value={contact.contactNumber}
                        onChange={handleChange}
                    />
                </div>
                <div className={styles.inputFieldContainer}>
                    <input 
                        className={styles.inputField}
                        id="email"
                        type="email"
                        placeholder="EMAIL"
                        name="email"
                        value={contact.email}
                        onChange={handleChange}
                    />
                </div>
            </div>

            {/* Message */}
            <div className={styles.contactUsFormContainer.concat(" mt-5")}>
                <div className={styles.inputFieldContainer}>
                    <textarea
                        className={styles.inputField}
                        id="message"
                        type="text"
                        placeholder="MESSAGE"
                        rows="5"
                        name="message"
                        value={contact.message}
                        onChange={handleChange}
                    />
                </div>
            </div>

            {/* Submit Button */}
            <div className={styles.contactUsFormContainer.concat(" mt-5")}>
                <button 
                    className="text-secondary font-bold py-2 rounded border border-secondary w-full lg:mr-5 focus:outline-none focus:shadow-outline" 
                    type="submit"
                    onClick={handleSubmit}
                >
                    SEND MESSAGE
                </button>
            </div>
        </div>
    </>
  )
}

export default ContactUsForm